/* eslint-disable react/jsx-props-no-spreading */
import React, {
    useContext, useEffect, useState, useRef,
} from 'react';
import { useReactiveVar } from '@apollo/client';
import { useRouterState } from 'app/hooks/useRouterState';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import connect from 'app/connect';
import { analyticService } from 'global/services';
import { dishes as sauceseDishes } from 'global/const/sauces';

/* CONTEXTS */
import { resetSelectedFiltersReaction } from 'app/hooks/useFilterHandlers';
import { OverlayContextDispatch, OverlayContextData } from 'app/containers/contexts/overlay.context';
import { TOP, MenuDispatchContext } from 'app/containers/contexts/menu.context';
import { menuDatesState } from 'app/containers/contexts/menuDates.context';
import { LocaleContext } from 'app/containers/LocaleProvider';

import {
    DEFAULT_CATEGORIES,
} from 'app/const/categories';
import { abTestDataContext } from 'app/containers/contexts/abTest.context';
import { isSubscription } from 'app/const/subscription';
import { DESKTOP_ANIMATION_PARAMS, MOBILE_ANIMATION_PARAMS } from 'app/const/menuAnimation';
import LINKS from 'app/const/links';
import { PAYMENT_PARAM_RECURRENT } from 'app/const/billing-payment-methods';

import { isDesktop } from 'app/utils/resolution';
import { Mobile, Desktop } from 'app/components/Responsive';
import { UIButton, UIParagraph } from 'app/components/ui';
import MenuCategoryList from 'app/components/MenuCategoryList';
import OpenBasketButton from 'app/components/OpenBasketButton';
import {
    useMenuPeriodsData,
    useSpecificPeriodData,
} from 'app/hooks/accessors';
/* BR-1077 */
import { MenuSkeletonPage } from 'app/components/Skeletons/MenuPageSkeletons/menu.skeleton';

import MenuDishesProvider from 'app/containers/MenuDishesProvider';

import Filters from 'app/views/Filters/Filters';
import { AchievementsOpener } from 'app/components/Achievements/AchievementsOpener';
import { AchievementsBannerBig } from 'app/components/Achievements/AchievementsBannerBig';
import { InviteFriendPopupOpener } from 'app/components/InviteFriendPopup';

import { useSelectedFilters } from 'app/connect/connectToSelectedFilters';
import { CookiesNotification } from 'app/components/ui/CookiesNotification/CookiesNotification';
import { getPeriod } from './defaultFilterUtils';
import RedirectToBasketWithGift from './components/RedirectToBasketWithGift';

import './menu.scss';
import { pickCategoryReaction, setDefaultFiltersReaction } from '../../../apollo/reactions/filters';
import { regionSubdivisionVar } from '../../../apollo/reaction';
import { useAddToBasketMutation } from './hooks';
import { useQueryAdapter } from './hooks/useQueryAdapter';
import NewMobileMenuContent from './components/BR1258/NewMobileMenuContent';
import { useParticipantIdABTest } from './hooks/useParticipantIdABTest';

class Menu extends React.Component {
    static getDerivedStateFromProps(props) {
        const {
            selectedFilters: {
                selectedPeriod,
                selectedCategoryId,
            },
        } = props;

        if (selectedPeriod && selectedCategoryId) {
            return { isFiltersSelected: true };
        }

        return null;
    }

    state = {
        filters: 'close', // open, close
        isFiltersSelected: false,
    };

    isDefaultFiltersSaved = false;

    setDefaultValues() {
        console.warn('Cтавить дефолтные значения в /menu – это пиздец');
        const {
            menuDatesContext: { state: menuDates },
            filterQuery: { menuFilter },
            selectedFilters: {
                isUserChangesTags,
            },
            urlQuery,
        } = this.props;

        // console.log(menuFilter);

        if (!menuFilter || this.isDefaultFiltersSaved) return;
        if (!menuDates || isEmpty(menuDates.rawDates)) return;

        const period = getPeriod({
            periodFromUrl: urlQuery.period,
            allPeriods: menuFilter.periods,
            location: window.location,
            menuDates,
        });

        console.log('URL QUERY????', urlQuery);

        const periodStart = period.start;

        const { categories: [category] } = period;

        // console.log(period, category);

        const categoryId = category.id;
        const defaultCategories = [...DEFAULT_CATEGORIES];

        let defaultTags = [];

        if (!isUserChangesTags && urlQuery.tags) {
            defaultTags = period.tags
                .filter((tag) => urlQuery.tags.includes(tag.id))
                .map((tag) => tag.id);
        }

        setDefaultFiltersReaction({
            variables: {
                periodStart,
                categoryId,
                categories: defaultCategories,
                tags: defaultTags,
            },
        });

        this.isDefaultFiltersSaved = true;
    }

    handleSelectCategory = async (categoryId) => {
        analyticService.push({ eventName: 'Categories_In_Viewport', categoryId });
        pickCategoryReaction({ categoryId });
    };

    handleSelectSelectionElement = async (scrollName) => {
        analyticService.push({ eventName: 'Categories_In_Viewport', scrollName });
    };

    handleOpenFilters = () => this.setState({ filters: 'open' });

    handleCloseFilters = () => {
        this.setState({ filters: 'close' });
    };

    handleToggleFilters = () => {
        // UI
        const { filters } = this.state;

        if (filters === 'open') {
            this.handleCloseFilters();
        } else {
            this.handleOpenFilters();
            analyticService.push({
                eventName: 'Change_Filter_Item',
                itemKey: 'open',
            });
        }
    };

    handleClickAddDishToBasket = (dishData) => {
        const { handleAddToBasketMutation } = this.props;
        handleAddToBasketMutation(dishData);
    };

    // DEPRECATED
    // createClearBasketWithDialogHandler = (specificAddToBasketFn) => async () => {
    //     const {
    //         basket_Query,
    //         dispatchOverlayContext: { pushDialogOverlay, closeLastOverlays },
    //         promocode: { promocode: promocodeFromCache },
    //         updateBilling,
    //         locale: { locale },
    //         handleCleanUrlParams,
    //     } = this.props;

    //     // определяем, установлен ли триальный промокод в кэш
    //     const isTrialPromocode = promocodeFromCache === TRIAL_FIRST_ORDER_SET.promoMenu;

    //     // функция подтверждения дилога
    //     const handleConfirmDialog = async () => {
    //         const { setIsBasketProcessing } = this.props;
    //         setIsBasketProcessing(true);

    //         closeLastOverlays();

    //         handleCleanUrlParams();

    //         /*
    //             очищается корзина и изменяются параметры оплаты
    //             В basket_Query.refetch не нужен clear, так как триальные блюда будут сами удалены из корзины
    //             из-за того, что в URL-е нет параметра extra=5x2 (он удаляется при закрытии корзины)
    //         */
    //         // await basket_Query.refetch({ clear: true });
    //         await baske_tQuery.refetch({ clear: true });
    //         promocodeVar('');

    //         await updateBilling({ variables: { promocode: '', payment_method: 'recurrent' } });
    //         subscriptionTypeVar(SUBSCRIPTION_TYPES.subscription);
    //         // специфичная для компонента блюда функция добавления в корзину (например, с анимацией)
    //         await specificAddToBasketFn();

    //         setIsBasketProcessing(false);
    //     };

    //     const dialogData = {
    //         ...dialogTexts[locale],
    //         onConfirm: handleConfirmDialog,
    //         notifyOnly: false,
    //         oneRowButtons: true,
    //     };

    //     /**
    //     * если не установлен триальный промокод и в корзине не находится триальный набор,
    //     * то просто доабвляем блюдо
    //     */
    //     if (!isTrialPromocode && basket_Query.cart.typeOfSet !== '5x2') {
    //         // специфичная для компонента блюда функция добавления в корзину (например, с анимацией)
    //         specificAddToBasketFn();
    //         return;
    //     }

    //     // иначе отображаем диалог очистки корзины и изменяем параметры оплаты
    //     pushDialogOverlay('clear_basket_dialog_menu', dialogData);
    // };

    handleResetFilters = () => {
        const {
            menuDispatchContext,
        } = this.props;

        analyticService.push({
            eventName: 'Change_Filter_Item',
            itemKey: 'clear',
        });

        resetSelectedFiltersReaction();

        const scrollingTimeout = 1000;

        setTimeout(() => {
            menuDispatchContext({
                type: 'scrollTo',
                payload: { target: TOP },
            });

            pickCategoryReaction({ categoryId: '3.1' });
        }, scrollingTimeout);
        sessionStorage.removeItem('chosenFilters');
    };

    renderResetFiltersButton() {
        const { isDishesUpdating } = this.props;

        const buttonText = 'Остальные блюда';

        const commonProps = {
            onClick: this.handleResetFilters,
            'aria-label': 'очистить фильтры',
        };

        const resetFiltersButtonContainerClasses = classNames({
            'menu__reset-filters-button-container': true,
            'menu-updating': isDishesUpdating,
        });

        const resetFiltersButtonDescriptionWrapClasses = classNames({
            'menu__reset-filters-button-description-wrapper': true,
        });

        return (
            <div styleName={resetFiltersButtonContainerClasses}>
                <Mobile>
                    <div styleName={resetFiltersButtonDescriptionWrapClasses}>
                        <UIParagraph level="5.1" styleName="menu__reset-filters-button-description">
                            Пока это все блюда
                            <br />
                            по&nbsp;выбранным фильтрам.
                            <br />
                            Но у нас есть ещё десятки классных блюд!
                        </UIParagraph>
                    </div>
                    <UIButton
                        colorType="secondary"
                        {...commonProps}
                    >
                        {buttonText}
                    </UIButton>
                </Mobile>

                <Desktop>
                    <button
                        type="button"
                        styleName="menu__reset-filters-button"
                        {...commonProps}
                    >
                        {buttonText}
                    </button>
                </Desktop>
            </div>
        );
    }

    renderDishes({ isFiltersOpen, menuDishesProps, showNewMenu }) {
        const {
            abTestDataContext,
            overlayIsOpen,
            showMenu,
            selectedFilters,
            filterQuery,
            basketQuery,
            userQuery,
            subscriptionTypeQuery: { subscriptionType },
            openDishDetails,
            openBasket,
            dishDetailsPathname,
            onMainDishesRendered,

            isMobileMenuDishesVisible,
            showFilterChangedAnimation,
            setDishesUpdatingState,
            isDishesUpdating,

            promocode: { promocode },
            onSetPeriod,
            setTemporaryBasketPeriod,
            cart,
        } = this.props;

        const isDesktopResolution = isDesktop();

        if ((!isDesktopResolution && (!showMenu))) return null;

        const isSubscriptionActivated = isSubscription(subscriptionType);

        const menuCategoryListProps = {
            addToBasketAnimationTarget: isDesktopResolution ? DESKTOP_ANIMATION_PARAMS : MOBILE_ANIMATION_PARAMS,
            isFiltersOpen,
            selectedFilters,
            filterQuery,
            basketQuery,
            userQuery,
            isSubscriptionActivated,
            isMobileMenuDishesVisible,
            showFilterChangedAnimation,
            onClickAddToBasket: this.handleClickAddDishToBasket,
            // createClearBasketWithDialogHandler: this.createClearBasketWithDialogHandler,
            openDishDetails,
            openBasket,
            onCategoryEntered: this.handleSelectCategory,
            onScrollElementEntered: this.handleSelectSelectionElement,
            dishDetailsPathname,
            onMainDishesRendered,
            setDishesUpdatingState,
            isDishesUpdating,
            overlayIsOpen,
            promocode,
            onSetPeriod,
            setTemporaryBasketPeriod,
        };

        const { hasDataForRenderDishes } = menuDishesProps;

        if (!hasDataForRenderDishes) return null;

        const menuDishesPropsWithoutSauces = {
            ...menuDishesProps,
            menuDishesQuery: {
                ...menuDishesProps?.menuDishesQuery,
                menuDishes: !isDesktop()
                    ? menuDishesProps?.menuDishesQuery?.menuDishes?.filter(
                        (d) => ![...sauceseDishes].includes(d.id),
                    )
                    : menuDishesProps?.menuDishesQuery?.menuDishes,
            },
        };

        return (
            <div styleName="menu__dishes-container">
                <MenuCategoryList
                    {...menuDishesPropsWithoutSauces}
                    {...menuCategoryListProps}
                />
                {!selectedFilters.isSelectedDefaultFilters && this.renderResetFiltersButton()}
                <Mobile>
                    <OpenBasketButton
                        onClick={openBasket}
                    // price={price}
                    // originalPrice={originalPrice}
                    // loading={basketQuery.loading || isBasketProcessing}
                    // promocodeConditions={basketQuery.cart.discount_conditions}
                    />
                    {/* UNTIL NY 2027 */}
                    {/* <AchievementsOpener>
                        {({ togglePopup }) => (
                            <AchievementsBannerBig
                                onClick={togglePopup}
                            />
                        )}
                    </AchievementsOpener> */}
                    {/* <OfferOpener isScalable={false} /> */}
                </Mobile>
                <Desktop>
                    <CookiesNotification
                        isScalable
                        pageClass="menu"
                    />
                    {/* <OfferOpener isScalable={false} /> */}
                </Desktop>
            </div>
        );
    }

    render() {
        const { filters, isFiltersSelected } = this.state;
        const {
            basketQuery,
            filterQuery: { menuFilter },
            selectedFilters: { selectedPeriod },
            openBasket,
            overlayIsOpen,
            showMenu,
            hiddenElements: {
                comment: isCommentHiddenByUrl,
                payment_button_recurrent: isRecurrentHiddenByUrl,
            },
            setDishesUpdatingState,
            onMainDishesRendered,

            selectedFilters,
            filterQuery,
            userQuery,
            subscriptionTypeQuery: { subscriptionType },
            openDishDetails,
            dishDetailsPathname,
            isMobileMenuDishesVisible,
            showFilterChangedAnimation,
            isDishesUpdating,
            promocode: { promocode },
            onSetPeriod,
            setTemporaryBasketPeriod,
            isBasketProcessing,
        } = this.props;

        const isFiltersOpen = filters === 'open';

        const period = menuFilter && menuFilter.periods.find((p) => p.start === selectedPeriod);
        const hideSubscription = period && period.hiddenPaymentMethods && period.hiddenPaymentMethods.includes(PAYMENT_PARAM_RECURRENT);
        const isNeededRenderSubscription = !(isRecurrentHiddenByUrl || hideSubscription);

        const menuClasses = classNames({
            /* стремный хак, чтобы в корзине не было лишнего скролла */
            'is-hidden': overlayIsOpen,
            menu: true,
        });

        const isDesktopResolution = isDesktop();

        if ((!isDesktopResolution && (!showMenu))) return null;

        const isSubscriptionActivated = isSubscription(subscriptionType);

        const menuCategoryListProps = {
            addToBasketAnimationTarget: isDesktopResolution ? DESKTOP_ANIMATION_PARAMS : MOBILE_ANIMATION_PARAMS,
            isFiltersOpen,
            selectedFilters,
            filterQuery,
            basketQuery,
            userQuery,
            isSubscriptionActivated,
            isMobileMenuDishesVisible,
            showFilterChangedAnimation,
            onClickAddToBasket: this.handleClickAddDishToBasket,
            // createClearBasketWithDialogHandler: this.createClearBasketWithDialogHandler,
            openDishDetails,
            openBasket,
            onCategoryEntered: this.handleSelectCategory,
            onScrollElementEntered: this.handleSelectSelectionElement,
            dishDetailsPathname,
            onMainDishesRendered,
            setDishesUpdatingState,
            isDishesUpdating,
            overlayIsOpen,
            promocode,
            onSetPeriod,
            setTemporaryBasketPeriod,
        };

        if (!isFiltersSelected) {
            return (
                <MenuSkeletonPage />
            );
        }

        if (!isDesktop()) {
            if (!showMenu) return null;
            return (
                <NewMobileMenuContent
                    isBasketProcessing={isBasketProcessing}
                    onMainDishesRendered={onMainDishesRendered}
                    isFiltersSelected={isFiltersSelected}
                    {...menuCategoryListProps}
                />
            );
        }

        return (
            <MenuDishesProvider
                wrapper="Menu => renderDishes"
                setDishesUpdatingState={setDishesUpdatingState}
                fetchPolicy="network-only"
                render={(menuDishesProps) => (
                    <>
                        {!menuDishesProps.hasDataForRenderDishes && (
                            <MenuSkeletonPage />
                        )}
                        <div styleName={menuClasses}>
                            <Desktop>
                                {menuDishesProps.hasDataForRenderDishes && (
                                    <>
                                        {isFiltersOpen && (
                                            <button
                                                type="button"
                                                aria-label="Закрыть фильтры"
                                                styleName="menu__close-filters"
                                                onClick={this.handleCloseFilters}
                                            />
                                        )}
                                        <Filters
                                            {...menuDishesProps}
                                            isCommentEditEnabled={!isCommentHiddenByUrl}
                                            // isNeededRenderSubscription={!isRecurrentHiddenByUrl}
                                            isNeededRenderSubscription={isNeededRenderSubscription}
                                            overlayIsOpen={overlayIsOpen}
                                            isFiltersOpen={isFiltersOpen}
                                            onToggle={this.handleToggleFilters}
                                            onClose={this.handleCloseFilters}
                                        />
                                    </>
                                )}
                                {/* <RedirectToBasketWithGift
                                    basketQuery={basketQuery}
                                    openBasket={openBasket}
                                /> */}
                            </Desktop>
                            {this.renderDishes({ isFiltersOpen, menuDishesProps })}
                            <InviteFriendPopupOpener />
                        </div>
                    </>
                )}
            />
        );
    }
}

Menu.propTypes = {
    abTestDataContext: PropTypes.shape({
        basket_preview_in_menu: PropTypes.string,
    }).isRequired,
    locale: PropTypes.shape({
        locale: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string.isRequired,
    }).isRequired,

    hiddenElements: PropTypes.shape({
        payment_button_recurrent: PropTypes.bool,
        comment: PropTypes.bool,
    }).isRequired,

    overlayIsOpen: PropTypes.bool.isRequired,
    showFilterChangedAnimation: PropTypes.bool.isRequired,

    updateBilling: PropTypes.func.isRequired,

    showMenu: PropTypes.bool.isRequired,
    isMobileMenuDishesVisible: PropTypes.bool.isRequired,

    filterQuery: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.shape({}),
        menuFilter: PropTypes.shape({
            periods: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,

    selectedFilters: PropTypes.shape({
        selectedPeriod: PropTypes.string,
        selectedCategoryId: PropTypes.string,
        selectedTags: PropTypes.arrayOf(
            PropTypes.string,
        ),
        isSelectedDefaultFilters: PropTypes.bool.isRequired,
        isUserChangesTags: PropTypes.bool.isRequired,
    }).isRequired,

    userQuery: PropTypes.shape({
        user: PropTypes.shape({}),
    }).isRequired,
    basketQuery: PropTypes.shape({
        cart: PropTypes.shape({
            sections: PropTypes.arrayOf(PropTypes.shape({})),
            totals: PropTypes.shape({
                total_discount_price: PropTypes.number,
            }),
        }),
        loading: PropTypes.bool,
        refetch: PropTypes.func,
    }),

    subscriptionTypeQuery: PropTypes.shape({
        subscriptionType: PropTypes.string.isRequired,
    }).isRequired,

    urlQuery: PropTypes.shape({
        period: PropTypes.string,
        category: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.string),
        categories: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,

    openDishDetails: PropTypes.func.isRequired,
    openBasket: PropTypes.func.isRequired,

    // Actions
    onSetPeriod: PropTypes.func.isRequired,
    setTemporaryBasketPeriod: PropTypes.func.isRequired,

    menuDispatchContext: PropTypes.func.isRequired,
    dishDetailsPathname: PropTypes.string.isRequired,
    onMainDishesRendered: PropTypes.func.isRequired,
    setDishesUpdatingState: PropTypes.func.isRequired,
    isDishesUpdating: PropTypes.bool.isRequired,

    dispatchOverlayContext: PropTypes.shape({
        pushDialogOverlay: PropTypes.func.isRequired,
        closeLastOverlays: PropTypes.func.isRequired,
    }).isRequired,
    promocode: PropTypes.shape({
        promocode: PropTypes.string,
    }).isRequired,

    handleCleanUrlParams: PropTypes.func.isRequired,
};

const MenuDataAccessContainer = (props) => {
    const [isBasketProcessing, setIsBasketProcessing] = useState(false);
    const specificPeriodData = useSpecificPeriodData();
    const appliedDefaultFiltersForPeriodRef = useRef(null);
    const subdivision = useReactiveVar(regionSubdivisionVar);
    const II = useMenuPeriodsData();
    // const III = useCachedBasketData();

    const filterQuery = {
        menuFilter: II,
    };

    useEffect(() => {
        const periodStart = specificPeriodData?.start;

        if (!periodStart) return;

        const cacheKey = `${subdivision}:${periodStart}`;
        if (appliedDefaultFiltersForPeriodRef.current === cacheKey) return;

        appliedDefaultFiltersForPeriodRef.current = cacheKey;
        setDefaultFiltersReaction({
            variables: {
                periodStart,
                categoryId: '3',
                categories: [...DEFAULT_CATEGORIES],
                tags: [],
            },
        });
    }, [specificPeriodData?.start, subdivision]);


    const [routerState] = useRouterState();
    const { history, location } = routerState;
    /* CONTEXTS */
    const localeContext = useContext(LocaleContext);
    const menuDatesContext = useContext(menuDatesState);
    const menuDispatchContext = useContext(MenuDispatchContext);
    const dispatchOverlayContext = useContext(OverlayContextDispatch);
    const overlayDataContext = useContext(OverlayContextData);
    const abTestData = useContext(abTestDataContext);
    // TODO: !!!!!


    const selectedFilters = useSelectedFilters();
    // TODO: тут ставиться дефолтное значение параметров в URL VI
    const queryProps = useQueryAdapter({ selectedFilters, history });
    const { handleAddToBasketMutation, basketLoading } = useAddToBasketMutation();

    // eslint-disable-next-line camelcase
    const { customization_in_basket, fetchABTestValue } = useContext(abTestDataContext);

    useEffect(
        () => {
            // eslint-disable-next-line camelcase
            const isUnfetched = customization_in_basket === 'unfetched';

            if (isUnfetched && !isDesktop()) {
                fetchABTestValue('customization_in_basket');
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );


    useEffect(
        () => {
            analyticService.push({
                eventName: 'Pageview',
                pagePath: 'main',
                pageUrl: window.location.href,
            });
        },
        [],
    );

    useEffect(() => {
        setIsBasketProcessing(basketLoading);
    }, [basketLoading]);

    return (
        <Menu
            {...props}
            {...queryProps}
            location={location}
            filterQuery={filterQuery}
            locale={localeContext}
            menuDatesContext={menuDatesContext}
            menuDispatchContext={menuDispatchContext}
            dispatchOverlayContext={dispatchOverlayContext}
            overlayDataContext={overlayDataContext}
            abTestDataContext={abTestData}
            handleAddToBasketMutation={handleAddToBasketMutation}
            isBasketProcessing={isBasketProcessing}
            setIsBasketProcessing={setIsBasketProcessing}
        />
    );
};

export default connect(MenuDataAccessContainer);

